import React from 'react';
import { ActionResult } from '@oysterjs/core/graphql/actions';
import { UpdateVoiceAgentMutation, VoiceAgentFieldsFragment } from '~/api/graphql';
import { usePendingChangesSave } from '~/components/settings/pending-changes-save';
import {
  voiceAgentFieldsToVoiceAgentInput,
  VoiceAgentSettingsFormInput
} from './voice_agent_form_input';

export function useVoiceAgentPendingChangesSave(params: {
  action: ActionResult<UpdateVoiceAgentMutation> | undefined;
  initialVoiceAgent: VoiceAgentFieldsFragment;
  toSavedState?: (agent: VoiceAgentFieldsFragment) => VoiceAgentSettingsFormInput;
  onAfterSave?: (saved: VoiceAgentSettingsFormInput) => void;
}) {
  const toSavedState = params.toSavedState ?? voiceAgentFieldsToVoiceAgentInput;
  const initialSavedState = React.useMemo(
    () => toSavedState(params.initialVoiceAgent),
    [params.initialVoiceAgent, toSavedState]
  );

  return usePendingChangesSave({
    initialSavedState,
    action: params.action,
    saveSuccessTrigger: params.action?.data?.updateVoiceAgent?.updatedAt,
    isSaveSuccessful: (saveAction) => !!saveAction?.data?.updateVoiceAgent?.id,
    getSavedStateAfterCommit: () => toSavedState(params.action!.data!.updateVoiceAgent!),
    onAfterSave: params.onAfterSave
  });
}
